import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.tags.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.tags.actionsLoading;
export const getItems = (state:RootState) => state.tags.items;
export const getItemsSelect = (state:RootState) => state.tags.dropDownItems;
export const getItemsCount = (state:RootState) => state.tags.itemsCount;
export const getItemForEdit = (state:RootState) => state.tags.itemForEdit;
export const getError = (state:RootState) => state.tags.error;
export const getErrorAction = (state:RootState) => state.tags.errorAction;
export const validationErrors = (state:RootState) => state.tags.validationErrors;
export const filters = (state:RootState) => state.tags.filters;